let shared: AudioContext | null = null;

/** The app's single AudioContext (created lazily; browsers start it suspended until a gesture). */
export function getAudioContext(): AudioContext {
  shared ??= new AudioContext({ latencyHint: 'interactive' });
  return shared;
}

/** Resumes the context. Call from a user gesture (click, key press) before playing. */
export async function unlockAudio(): Promise<AudioContext> {
  const ctx = getAudioContext();
  if (ctx.state !== 'running') await ctx.resume();
  return ctx;
}
